// extracted by mini-css-extract-plugin
export var button = "_ba-4";
export var hasDarkBackground = "_ba-7";
export var hasLightBackground = "_ba-6";
export var iconWrapper = "_ba-0";
export var large = "_ba-2";
export var medium = "_ba-1";
export var small = "_ba-5";
export var xsmall = "_ba-3";